var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveResource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_3dcube",
    "data-name": "vuesax/bold/3dcube",
    transform: "translate(-300 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3dcube",
    "data-name": "3dcube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(324 532) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-veteran-4311495",
    transform: "translate(288.974 506.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51822",
    "data-name": "Group 51822",
    transform: "translate(14.9 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M30.341,2.5H15.71a.82.82,0,0,0-.81.81V9.815a1.115,1.115,0,0,0,.6,1l4.746,2.616.509-1.111a2.494,2.494,0,0,1,4.537,0l.486,1.111,4.769-2.616a1.115,1.115,0,0,0,.6-1V3.31A.805.805,0,0,0,30.341,2.5Z",
    transform: "translate(-14.9 -2.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M34.791,50.02l-3.172-.347a.445.445,0,0,1-.347-.255L29.953,46.5a.778.778,0,0,0-1.412,0L27.221,49.4a.485.485,0,0,1-.347.255L23.7,50a.775.775,0,0,0-.44,1.343L25.6,53.493a.467.467,0,0,1,.139.417l-.648,3.125a.773.773,0,0,0,1.134.833l2.8-1.574a.49.49,0,0,1,.44,0l2.755,1.574a.773.773,0,0,0,1.134-.833l-.625-3.125a.467.467,0,0,1,.139-.417l2.361-2.13A.779.779,0,0,0,34.791,50.02Z",
    transform: "translate(-21.133 -35.968)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveResource);
export default __webpack_public_path__ + "static/media/active_resource.c9ae5e2c89b15c30e4f05f2d6ff86fb1.svg";
export { ForwardRef as ReactComponent };